import './index.scss';
import React, { PropTypes } from 'react';
import { browserHistory } from 'react-router';

const BackLink = React.createClass({
    propTypes: {
        invisible: PropTypes.bool
    },
    goBack: function() {
        browserHistory.goBack();
    },
    render: function() {

        let linkHolderClassName = 'back-link-holder';
        if(this.props.invisible)
        {
            linkHolderClassName = 'invisible-back-link-holder';
        }

        return <div className={linkHolderClassName}>
                <a className="pagination__prev" onClick={this.goBack}>Back</a>
            </div>;
    }
});

export default BackLink;


// WEBPACK FOOTER //
// ./src/components/common/BackLink/index.jsx